import { useState } from "react";
import SSRCategoriesTable from "../../../../components/Products/Flights/SSR/SSRCategoriesTable";
import SSRItemsTable from "../../../../components/Products/Flights/SSR/SSRItemsTable";
import styles from "./SSRManagement.module.css";

const SSRManagement = () => {
  const [activeTab, setActiveTab] = useState("items"); // 'categories' or 'items'

  return (
    <div className={styles.pageContainer}>
      {/* Page Header */}
      <div className={styles.pageHeader}>
        <div className={styles.headerContent}>
          <div className={styles.headerIcon}>🎫</div>
          <div className={styles.headerText}>
            <h1 className={styles.pageTitle}>SSR Management</h1>
            <p className={styles.pageSubtitle}>
              Special Service Requests - Manage categories and service items
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === "items" ? styles.tabActive : ""}`}
          onClick={() => setActiveTab("items")}
        >
          <span className={styles.tabIcon}>📝</span>
          <span className={styles.tabText}>SSR Items</span>
          <span className={styles.tabBadge}>Master Data</span>
        </button>
        <button
          className={`${styles.tab} ${activeTab === "categories" ? styles.tabActive : ""}`}
          onClick={() => setActiveTab("categories")}
        >
          <span className={styles.tabIcon}>📂</span>
          <span className={styles.tabText}>SSR Categories</span>
          <span className={styles.tabBadge}>Read-Only</span>
        </button>
      </div>

      {/* Tab Content */}
      <div className={styles.tabContent}>
        {activeTab === "items" && <SSRItemsTable />}
        {activeTab === "categories" && <SSRCategoriesTable />}
      </div>
    </div>
  );
};

export default SSRManagement;